import { actionCreatorFactory } from "typescript-fsa";

const createAction = actionCreatorFactory("EXTERNAL_RESOURCES");

export interface OpenExternalResourceAttachmentLinkActionParams {
  entityUuid: string;
  entityType: string;
}

export const openExternalResourceAttachmentAction = createAction.async<
  OpenExternalResourceAttachmentLinkActionParams,
  null
>("OPEN_ATTACHMENT");

export interface OpenCommunicationLinkActionParams {
  type: string;
  entityUuid: string;
  entityType: string;

  onSuccess?: () => void;
}

export const openCommunicationLinkAction = createAction.async<OpenCommunicationLinkActionParams, null>(
  "OPEN_COMMUNICATION_LINK",
);
